import React, { useState } from 'react';

import { GrowthBook, GrowthBookProvider } from '@growthbook/growthbook-react';
import { analytics } from '@features/analytics';
import Cookies from 'js-cookie';

export function FeatureFlagProvider({ children, clientKey, siteSlug }) {
  const [gb] = useState(() => {
    const gb = new GrowthBook({
      apiHost: 'https://growthbook-proxy.control.onejourney.travel',
      clientKey,
      attributes: { id: Cookies.get('gbuuid'), siteSlug },
      trackingCallback: (experiment, result) => {
        analytics.track({
          event: 'experiment_viewed',
          params: {
            experiment_id: experiment.key,
            variation_id: result.variationId,
            site_slug: siteSlug,
          },
        });
      },
    });

    gb.init({
      streaming: false,
      timeout: 2000,
    });

    return gb;
  });

  return <GrowthBookProvider growthbook={gb}>{children}</GrowthBookProvider>;
}
